module.exports = __webpack_public_path__ + "img/IdeaBox.485d2d8d.png";